import BaseModel from '@core/model';

import AgreementStatusEnum from '@constants/enums/agreement/status';

import AgreementApi from '@packages/agreements/api';

import { Adviser, Investor, EsignAgreementParticipant } from '@/models';

export class Agreement extends BaseModel {
    static name = 'Agreement';
    static entity = 'agreements';
    static Api = AgreementApi;

    static fields() {
        return {
            id: this.string(null).nullable(),
            name: this.string(null).nullable(),
            status: this.enum(AgreementStatusEnum).nullable(),
            adviser_id: this.string(null).nullable(),
            adviser: this.belongsTo(Adviser, 'adviser_id'),
            investor_id: this.string(null).nullable(),
            investor: this.belongsTo(Investor, 'investor_id'),
            external_id: this.string(null).nullable(),
            signatories: this.modelList(EsignAgreementParticipant, []).nullable(),
            created_at: this.string(null).nullable(),
            last_updated: this.string(null).nullable()
        };
    }
}

export default Agreement;
